import { render, staticRenderFns } from "./EditTournamentStage.vue?vue&type=template&id=c9340b94"
import script from "./EditTournamentStage.vue?vue&type=script&lang=js"
export * from "./EditTournamentStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports